import Api from '../Api';

import { url } from './config';
import { Currency } from './types';

const api = new Api<Currency>(url);

export default api;
